import { FilterBuilder } from '@/shared/filters/filter-builder';
import { ProjectFilterInput } from '@/shared/types/types.generated';

export class ProjectsFilterBuilder extends FilterBuilder<
  ProjectFilterInput,
  ProjectsFilterBuilder
> {
  public allowedFilters: Array<keyof ProjectFilterInput> = [
    'name',
    'vendorId',
    'ideConfigId',
    'projectType',
    'tag',
    'creationTimestamp',
    'groupId',
  ];

  constructor() {
    super();

    this.fieldMappings = {
      name: 'nameLower' as keyof ProjectFilterInput,
    };

    this.valueTransformers = {
      name: (value: string) => value.toLowerCase(),
    };
  }
}
